export function isElementWithChildren(element) {
    return Object.hasOwnProperty.call(element, 'children');
}
